import { NavLink } from "react-router-dom";

export interface ISideNavRoutes {
  display: string;
  path: string;
  icon?: JSX.Element;
  exact?: boolean;
}
function SideNav({ routes, className }: { routes: ISideNavRoutes[]; className?: string }) {
  return (
    <div className={"h-full w-16 md:w-full md:pt-8 bg-white border-r text-gray-600 " + className}>
      {routes.map((route, i) => (
        <NavLink to={route.path} exact={route.exact} key={i} activeClassName="active-side-nav" className="flex items-center w-full h-12 animate  text-lg font-semibold hover:text-black hover:bg-gray-100 group">
          <div className="w-1.5 h-12 mr-4 group-hover:bg-gray-600 animate duration-1000"></div>
          {route.icon}
          <span className="ml-4 hidden md:block text-base">{route.display}</span>
        </NavLink>
      ))}
    </div>
  );
}

export default SideNav;
